import { useEffect, useState } from 'react';
import _ from 'lodash';

const useCart = cartItems => {
	const [items, setItems] = useState(cartItems.length);
	const [quantity, setQuantity] = useState(0);
	const [total, setTotal] = useState(0.0);

	useEffect(() => {
		let sub_quantity = 0,
			sub_total = 0;
		setItems(cartItems.length);
		_.forEach(cartItems, item => {
			const productprice = item?.promotion_price > 0 ? item.promotion_price : item.price
			sub_quantity += item.quantity;
			sub_total += parseFloat(productprice) * item.quantity;
		});
		setQuantity(sub_quantity);
		setTotal(sub_total);
	}, [cartItems]);

	return { items, quantity, total: total.toFixed(2) };
};

export default useCart;
